// extracted by mini-css-extract-plugin
module.exports = {"con":"intro_con__35-6O","lef":"intro_lef__1M_wQ","rig":"intro_rig__3z6UE"};